module.exports = __webpack_public_path__ + "static/media/big_tree.58129870.png";